'use client'

import { useState } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import dynamic from 'next/dynamic'

import { createQueryClient } from '@/lib/query/query-client'

// Dynamically imported — fully excluded from the production bundle so the
// devtools' internal use of Function() never triggers a CSP 'unsafe-eval' violation.
const ReactQueryDevtools =
  process.env.NODE_ENV === 'development'
    ? dynamic(
        () => import('@tanstack/react-query-devtools').then((m) => ({ default: m.ReactQueryDevtools })),
        { ssr: false },
      )
    : () => null

type QueryProviderProps = {
  children: React.ReactNode
}

export function QueryProvider({ children }: QueryProviderProps) {
  const [client] = useState(() => createQueryClient())

  return (
    <QueryClientProvider client={client}>
      {children}
      <ReactQueryDevtools buttonPosition="bottom-left" initialIsOpen={false} />
    </QueryClientProvider>
  )
}
